import { render, staticRenderFns } from "./FormNewOrgBattery.vue?vue&type=template&id=385cd8b4&"
import script from "./FormNewOrgBattery.vue?vue&type=script&lang=js&"
export * from "./FormNewOrgBattery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports